__turbopack_context__.v({
  "chevron": "type-aircraft-select-module-scss-module__CLzp8a__chevron",
  "chevronOpen": "type-aircraft-select-module-scss-module__CLzp8a__chevronOpen",
  "dropdown": "type-aircraft-select-module-scss-module__CLzp8a__dropdown",
  "inputIcon": "type-aircraft-select-module-scss-module__CLzp8a__inputIcon",
  "label": "type-aircraft-select-module-scss-module__CLzp8a__label",
  "option": "type-aircraft-select-module-scss-module__CLzp8a__option",
  "placeholder": "type-aircraft-select-module-scss-module__CLzp8a__placeholder",
  "root": "type-aircraft-select-module-scss-module__CLzp8a__root",
  "selectContainer": "type-aircraft-select-module-scss-module__CLzp8a__selectContainer",
  "selectField": "type-aircraft-select-module-scss-module__CLzp8a__selectField",
  "selectText": "type-aircraft-select-module-scss-module__CLzp8a__selectText",
  "selected": "type-aircraft-select-module-scss-module__CLzp8a__selected",
});
